<template>
  <div class="ac-card" :style="customStyle">
    <div class="ac-card-header">
      <slot name="header" />
    </div>
    <div class="ac-card-body" :style="customStyleBody">
      <slot />
    </div>
    <div class="ac-card-footer">
      <slot name="footer" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    customStyle: {
      type: Object,
      default: () => {
        return {
          borderRadius: "4px",
        };
      },
    },
    customStyleBody: {
      type: Object,
      default: () => {
        return {
          height: "inherit",
        };
      },
    },
  },
};
</script>


<style lang="css" scoped>
.ac-card {
  background-color: white;
  width: 100%;
  display: flex;
  flex-direction: column;
  border: 1px solid rgba(234, 237, 240, 1);
  /* box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33); */
}

.ac-card-shadow {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
}
</style>
